// extracted by mini-css-extract-plugin
export default {"item":"styles_item__K+bcg","link":"styles_link__8KoKs","current":"styles_current__bC7nL","container":"styles_container__FLjfK"};